import { useEffect } from "react";
import { PageContainer } from "@/app/layouts/PageContainer";

export function JobsRedirectPage() {
  useEffect(() => {
    window.location.assign("/admin/jobs");
  }, []);
  return (
    <PageContainer>
      <p>Redirecting to Hangfire dashboard…</p>
      <p className="text-sm text-muted-foreground">If you are not redirected automatically, <a className="underline" href="/admin/jobs">click here</a>.</p>
    </PageContainer>
  );
}
